import { Text, Title, DetailText } from "../../components/units/Text"
import { CommisionProps } from "../../components/Rest/Commission"
import { useSignedInContext } from "../../context/AuthContextProvider";
import { useState, useEffect } from "react";
import { data, useParams } from 'react-router-dom';
import { BoxWrapper } from "../../components/Wrappers/Wrappers";
import { LgFormInput, LgFormCkeckBox, LgSelect, LgFileInput } from "../../components/Form/FormInput";
import { fetchCommissionData, updateCommissionData } from "../../components/Rest/Commission";
import { RestApiState } from "../../components/Rest/Organization";

interface UpdateCommissionProps {
    commission: {
        data: CommisionProps | null;
        changes: Set<keyof CommisionProps>;
        requestState: RestApiState;
        timeOutId: NodeJS.Timeout | null;
        documentation?: any;
    }
}


const defaultUpdateCommissionState = { commission:{
    data: null,
    changes: new Set<keyof CommisionProps>(['is_cooling_activity', 'is_heating_activity', 'is_default_activity', 'is_waterproof_activity']),
    requestState: RestApiState.Idle,
    timeOutId: null

}}


function submitClassHandler(status: RestApiState): string {
    // Defines css class based on status
    if (status === RestApiState.Success) {
        return "submit-btn-success"
    }

    if (status !== RestApiState.Idle)  {
        return 'submit-btn disabled'
    }

    return "bg-secondary text-light"
}


export const UpdateCommission = () => {
    const { user } = useSignedInContext()
    const { serial_number } = useParams()

    const [commissionProps, setProps] = useState<UpdateCommissionProps>(defaultUpdateCommissionState)

    if (serial_number === undefined) {
        throw new Error("Serial number must be provided as parameter");
    }

    useEffect(() => {
        async function myFunction() {
            if (commissionProps.commission.requestState !== RestApiState.Idle) {
                updateRestApiStatus(RestApiState.Idle);
            }
        }

        if (commissionProps.commission.timeOutId !== null) {
            clearTimeout(commissionProps.commission.timeOutId)
        }

        if (commissionProps.commission.requestState !== RestApiState.Pending && commissionProps.commission.requestState !== RestApiState.Idle) {
            let timeOut = setTimeout(myFunction, 1500);
            setProps((prev) => ({
                ...prev,
                commission: {
                    ...prev.commission,
                    timeOutId: timeOut, // Update the requestState field
                },
            }));
        }

    }, [commissionProps.commission.requestState])

    const statusText = ():string => {
        let text = ''
        switch(commissionProps.commission.requestState) {
            case RestApiState.Idle : text = "" ; break;
            case RestApiState.Pending : text = "Обновляется"; break;
            case RestApiState.Success : text = "Обновлено"; break;
            case RestApiState.BadRequest : text = "Заполните поля"; break;
            case RestApiState.ServerError : text = "Ошибка сервера"; break;
            case RestApiState.Unknown : text = "Неизвестная ошибка"; break;
            default: text = "..."; break;
        }
        return text
    }

    const setCommissionData = (newData: typeof commissionProps.commission.data): void => {
        setProps(prev => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: newData,
            },
        }));
    }


    const updateDataValue = (e: React.ChangeEvent<HTMLInputElement>):void => {
        const { name, value } = e.target;
        const key = name as keyof CommisionProps;
        setProps((prev) => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: prev.commission.data
                ? { ...prev.commission.data, [key]: value }
                : null,
            },
        }));
        
        setProps((prevState) => {
            const updatedChanges = new Set(prevState.commission.changes); // Clone the current Set
            updatedChanges.add(key); // Add the new key
            return {
                ...prevState,
                commission: {
                    ...prevState.commission,
                    changes: updatedChanges, // Update changes with the new Set
              },
            };
        });
    };

    const fileChangeHandler = (e: any) => {
        const file = e.target.files[0]

        if (file) {
            const validTypes = ['application/pdf'];
            const maxSize = 1000 * 1024;
      
            // Validate file type
            if (!validTypes.includes(file.type)) {
                alert("Допустимые форматы PDF")
                return;
            }
    
            // Validate file size
            if (file.size > maxSize) {
                alert(`Допустимый размер менее ${maxSize}KB. ${file.size}`)
                return;
            }

            setProps((prev) => ({
                ...prev,
                commission: {
                    ...prev.commission,
                    documentation: file
                }
            }))
        } else {
            setProps((prev) => ({
                ...prev,
                commission: {
                    ...prev.commission,
                    documentation: undefined
                }
            }))
        }
    }

    const updateBooleanDataValue = (e: React.ChangeEvent<HTMLInputElement>):void => {
        const { name, value } = e.target;
        const key = name as keyof CommisionProps;
        setProps((prev) => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: prev.commission.data
                ? { ...prev.commission.data, [key]: e.target.checked }
                : null,
            },
        }));
        
        setProps((prevState) => {
            const updatedChanges = new Set(prevState.commission.changes); // Clone the current Set
            updatedChanges.add(key); // Add the new key
            return {
                ...prevState,
                commission: {
                    ...prevState.commission,
                    changes: updatedChanges, // Update changes with the new Set
              },
            };
        });
    };

    const updateRestApiStatus = (status: RestApiState) => {
        setProps((prev) => ({
            ...prev,
            commission: {
                ...prev.commission,
                requestState: status, // Update the requestState field
            },
        }));
    }

    useEffect(() => {
        const fetchSectionData = async () => {
            fetchCommissionData(serial_number, user.role_slug, setCommissionData)
        }
        fetchSectionData()
    }, [])

    const handelSubmit = (e: any) => {
        e.preventDefault();
        if (commissionProps.commission.data === null) {
            throw new Error("Commission cant be empty");
        }
        const dict: Partial<Record<keyof CommisionProps, any>> = {};
        commissionProps.commission.changes.forEach((key) => {
            dict[key] = commissionProps.commission.data?.[key];
        });
        
        if (commissionProps.commission.documentation) {
            dict['documentation'] = commissionProps.commission.documentation
        }

        updateCommissionData(serial_number, user.role_slug, dict, updateRestApiStatus)
    }
    
    return (
        <div className='content-wrapper flex-grow acb-dashboard-wrapper show-up'>
            <DetailText href={`/react/acb/detail/${serial_number}`}>
                    Назад
            </DetailText>
            <br />
            <br />
            <Title className="dispaly-block">{serial_number}</Title>
            <br />
            <BoxWrapper bg="bg-primary" p="p3" r="r15">
                <Text size="lg" className="bold dispaly-block">Форма ввода в эскплуатацию</Text>
                <br />
                {commissionProps.commission.data ? (
                    <form onSubmit={handelSubmit} className="organization-form">
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Изображение</Text>
                            <Text size="base" className="dispaly-block">Выберите изображение</Text>
                            <div className="flex flex-wrap">
                                
                                {commissionProps.commission.data.image_choices.map((option) => (
                                    <div className="img-box r5 overflow-hidden cursor-pointer"
                                        style={{
                                            width: '125px',
                                            height: '125px',
                                            border: option.value === commissionProps.commission.data?.image ? '1px solid #FF7D7A' : ''
                                        }}
                                        onClick={(e:any) => {
                                            const newImage = option.value as number
                                            setProps((prev) => ({
                                                ...prev,
                                                commission: {
                                                  ...prev.commission,
                                                  data: prev.commission.data
                                                    ? { ...prev.commission.data, image: newImage }
                                                    : null,
                                                },
                                            }));
                                            
                                            setProps((prevState) => {
                                                const updatedChanges = new Set(prevState.commission.changes); // Clone the current Set
                                                updatedChanges.add('image'); // Add the new key
                                                return {
                                                    ...prevState,
                                                    commission: {
                                                        ...prevState.commission,
                                                        changes: updatedChanges, // Update changes with the new Set
                                                  },
                                                };
                                            });
                                        }}
                                    >
                                        <img 
                                            src={`${process.env.REACT_APP_DJANGO_SERVER_URL}${option.label}`} 
                                            alt="" 
                                            style={{
                                               objectFit: "contain"
                                            }}    
                                        />
                                    </div>
                                ))}
                            </div>
                            <div style={{display: 'none'}}>
                            
                            <LgSelect 
                                    value={commissionProps.commission.data.image} 
                                    label='Избражение' 
                                    name='image' 
                                    valueSetter={updateDataValue} 
                                    options={[
                                        {value: '', label: "Не выбрано"},
                                        ...commissionProps.commission.data.image_choices.map(item => ({
                                        value: item.value,
                                        label: item.label ? item.label : '',
                                    }))]}
                                />
                            </div>
                            
                        </div>
                        <br /><br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Основные свойства</Text>
                            <LgFormInput 
                                value={commissionProps.commission.data.voltage} 
                                label='Наряжение Кв.' 
                                name='voltage' 
                                type='number' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.nominal_capacity} 
                                label='Номинальная емкость (Ач)' 
                                name='nominal_capacity' 
                                type='number' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.weight} 
                                label='Вес (Кг)' 
                                name='weight' 
                                type='number' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.size} 
                                label='Габаритные размеры' 
                                name='size' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.cycle_capacity} 
                                label='Срок службы (циклы)' 
                                name='cycle_capacity' 
                                type='number' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Исполнение</Text>
                            <LgFormCkeckBox 
                                value={commissionProps.commission.data.is_cooling_activity} 
                                label='Исполнение охлаждение' 
                                name='is_cooling_activity' 
                                required={false} 
                                valueSetter={updateBooleanDataValue} 
                            />
                            <LgFormCkeckBox 
                                value={commissionProps.commission.data.is_heating_activity} 
                                label='Исполнение отопление' 
                                name='is_heating_activity'  
                                required={false} 
                                valueSetter={updateBooleanDataValue} 
                            />
                            <LgFormCkeckBox 
                                value={commissionProps.commission.data.is_default_activity} 
                                label='Исполнение по умолчанию' 
                                name='is_default_activity'
                                required={false} 
                                valueSetter={updateBooleanDataValue} 
                            />
                            <LgFormCkeckBox 
                                value={commissionProps.commission.data.is_waterproof_activity} 
                                label='Исполнение водоустойчевость' 
                                name='is_waterproof_activity' 
                                required={false} 
                                valueSetter={updateBooleanDataValue} 
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Прочее</Text>
                            <LgFormInput 
                                value={commissionProps.commission.data.sku} 
                                label='Артикул' 
                                name='sku' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgSelect 
                                value={commissionProps.commission.data.chemistry} 
                                label='Тип химии' 
                                name='chemistry' 
                                valueSetter={updateDataValue} 
                                options={commissionProps.commission.data.chemistry_choices} 
                            />
                            <LgSelect 
                                value={commissionProps.commission.data.elements} 
                                label='Тип элементов' 
                                name='elements' 
                                valueSetter={updateDataValue}
                                options={commissionProps.commission.data.elements_choices}
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.batch_code} 
                                label='Код партии элементов' 
                                name='batch_code' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgSelect 
                                value={commissionProps.commission.data.model_name} 
                                label='Модель АКБ' 
                                name='model_name' 
                                valueSetter={updateDataValue} 
                                options={commissionProps.commission.data.model_name_choices}
                            />
                            <LgSelect 
                                value={commissionProps.commission.data.contactors} 
                                label='Тип контакторов' 
                                name='contactors' 
                                valueSetter={updateDataValue} 
                                options={commissionProps.commission.data.contactors_choices}
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.bms_model} 
                                label='Модель BMS' 
                                name='bms_model' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFormInput 
                                value={commissionProps.commission.data.bms_hw_version} 
                                label='Версия платы BMS (HW)' 
                                name='bms_hw_version' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <Text size="lg" className="bold dispaly-block">Администрация</Text>
                            <LgFormInput 
                                value={commissionProps.commission.data.comment} 
                                label='Комментарий' 
                                name='comment' 
                                type='text' 
                                required={false} 
                                valueSetter={updateDataValue} 
                            />
                            <LgFileInput
                                serverFile={commissionProps.commission.data.documentation} 
                                label='Документация' 
                                name='documentation' 
                                required={false} 
                                valueSetter={fileChangeHandler} />
                        </div>
                        <br />
                        <br />
                        <div className="flex flex-column">
                            <button 
                                type="submit"
                                disabled={ commissionProps.commission.requestState !== RestApiState.Idle }
                                className={`${submitClassHandler(commissionProps.commission.requestState)} p2 bold` }
                                style={{position:'relative', width: '100%', borderRadius: '5px', outline:'none', border: 'none'}}
                                >
                                { commissionProps.commission.requestState === RestApiState.Idle && <Text  className="slide-bottom-to-top">Сохранить</Text>  }
                                { commissionProps.commission.requestState === RestApiState.Pending && <Text className="slide-bottom-to-top">{ <div className="btnloader"></div> }</Text>}
                                { (commissionProps.commission.requestState !== RestApiState.Pending && commissionProps.commission.requestState !== RestApiState.Idle) && <Text className="slide-bottom-to-top">{ statusText() }</Text>} 
                            </button>
                            <DetailText bg="bg-danger" p="p2" r="r10" color="light" className="bold text-center r5" href={`/react/acb/${serial_number}/review-commission`} style={{width: '100%', height: '36px !important'}}>Страница ввода в эскплуатацию</DetailText>
                        </div>

                        
                        
                    </form>
                ) : (
                    <h1>Loading...</h1>
                )}
            </BoxWrapper>

        </div>
    )
}


export const UpdateCommissionComment = () => {
    return (
        <div className='content-wrapper flex-grow acb-dashboard-wrapper show-up'>
            <h1>Hello world</h1>
        </div>
    )
}